import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import HeaderBar from "../components/HeaderBar";

import EditGeneral from "./EditGeneral";
import EditProfilePic from "./EditProfilePic";
import EditEducation from "./EditEducation";
import EditCareer from "./EditCareer";

const Edit = ({ children, activeKey, ...props }) => {
  return (
    <>
      <HeaderBar heading="Edit Profile" />
      <Container>
        <Row className="justify-content-center mt-4">
          <Col md="8" className="mb-4">
            <EditGeneral />
            <EditProfilePic />
            <EditEducation />
            <EditCareer />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Edit;
